import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useGenerateForgotPasswordToken, useNewPassword } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import { AuthSuggestion, DesktopAuthHeader } from 'components';

import { Form } from './components';

const NewPassword: React.FC = () => {
  const { t } = useTranslation('component.auth.newPassword');
  const [csrfToken, setCsrfToken] = React.useState<string>('');

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const { mutateAsync: sendForgotPasswordCode, isLoading } =
    useGenerateForgotPasswordToken();

  const { mutateAsync: submit } = useNewPassword(csrfToken);

  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  React.useEffect(() => {
    if (token) {
      sendForgotPasswordCode({
        code: token,
        email: email,
      })
        .then((res) => {
          if (res?.token) {
            setSearchParams({ email: email });
            setCsrfToken(res.token);
          }
        })
        .catch(() => {
          navigate(routes.auth.forgotPassword.url);
        });
    } else {
      navigate(routes.auth.forgotPassword.url);
    }
  }, []);

  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
    >
      <DesktopAuthHeader title={t('newPassword')} />
      <Form
        onButton={(data) =>
          submit({ ...data, username: searchParams.get('email') }).then(() => {
            navigate(routes.auth.signIn.url);
          })
        }
        loading={isLoading}
      />
      <AuthSuggestion include={['sign-up']} />
    </Box>
  );
};

export default NewPassword;
